import Pill from 'components/Pill';
import {FC} from 'react';
import {useBackend} from 'state/backend';
import {twMerge} from 'tailwind-merge';
import {t} from 'ttag';

import {BackendData} from '../../types';
import ModalFlowDelete from '../ModalFlowDelete';
import ModalFlowEdit from '../ModalFlowEdit';
import {flowUsers} from './styles.module.css';

const _getUsersInStep = (
    steps: BackendData['data']['approvalFlows'][0]['steps'],
    data: BackendData['data'],
): BackendData['data']['users'] => {
    steps.sort((a, b) => a.position - b.position);
    const users = steps.map((step) => {
        const user = data.users.find((user) => user.mid === step.teamMid);
        if (!user) throw new Error('User not found');
        return user;
    });
    return users;
};

export const ApprovalSettingsFlowsList: FC<{
    documentType: string;
}> = ({documentType}) => {
    const {data} = useBackend<BackendData>();
    const approvalFlows = data.approvalFlows.filter(
        (flow) => flow.documentType === documentType,
    );

    return (
        <div className="flex flex-col gap-2">
            {approvalFlows.map((flow) => (
                <div
                    className="flex flex-col rounded border border-grey-100"
                    id={`approval-flow-${flow.mid}`}
                    key={flow.mid}
                >
                    <div className="flex bg-grey-100 px-4 py-2">
                        <div className="flex-1">{flow.name}</div>
                        <div className="flex gap-2">
                            <ModalFlowEdit mid={flow.mid} />
                            <ModalFlowDelete mid={flow.mid} />
                        </div>
                    </div>
                    <div
                        className={twMerge(
                            'max-h-96 overflow-y-scroll scroll-shadow-y',
                            flowUsers,
                        )}
                    >
                        {_getUsersInStep(flow.steps, data).map(
                            (user, index) => {
                                const revokedLabel = user.revoked ? (
                                    <Pill
                                        color="gold"
                                        isTruncated={false}
                                        label={t`Revoked`}
                                    />
                                ) : null;
                                return (
                                    <div key={`${user.mid}-${index}`}>
                                        <div>{index + 1}</div>
                                        <div className="inline-flex gap-2">
                                            <span>{user.name}</span>
                                            {revokedLabel}
                                        </div>
                                    </div>
                                );
                            },
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};
